var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 21.4141C6.4 21.4141 5.45833 21.0224 4.675 20.2391C3.89167 19.4557 3.5 18.5141 3.5 17.4141V4.41406H20.5C21.05 4.41406 21.5208 4.6099 21.9125 5.00156C22.3042 5.39323 22.5 5.86406 22.5 6.41406V9.41406C22.5 9.96406 22.3042 10.4349 21.9125 10.8266C21.5208 11.2182 21.05 11.4141 20.5 11.4141H18.5V17.4141C18.5 18.5141 18.1083 19.4557 17.325 20.2391C16.5417 21.0224 15.6 21.4141 14.5 21.4141H7.5ZM8.5 6.41406H16.5H5.5H8.5ZM18.5 9.41406H20.5V6.41406H18.5V9.41406ZM14.5 19.4141C15.05 19.4141 15.5208 19.2182 15.9125 18.8266C16.3042 18.4349 16.5 17.9641 16.5 17.4141V6.41406H10.5V6.81406L12.3 8.26406C12.3333 8.2974 12.4 8.43073 12.5 8.66406V12.9141C12.5 13.0474 12.45 13.1641 12.35 13.2641C12.25 13.3641 12.1333 13.4141 12 13.4141H8C7.86667 13.4141 7.75 13.3641 7.65 13.2641C7.55 13.1641 7.5 13.0474 7.5 12.9141V8.66406C7.5 8.63073 7.56667 8.4974 7.7 8.26406L9.5 6.81406V6.41406H5.5V17.4141C5.5 17.9641 5.69583 18.4349 6.0875 18.8266C6.47917 19.2182 6.95 19.4141 7.5 19.4141H14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreak);
export default __webpack_public_path__ + "static/media/break.1e0aa998e4f9984b153bf440545020cb.svg";
export { ForwardRef as ReactComponent };